import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationsService from "../../services/NotificationsService";
import Form from "../Form/Form";
import Input from "../Input/Input";
import ToggleButton from "../ToggleButton/ToggleButton";
import { useAuth } from "../../contexts/auth";
import Button from "../Button/Button";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";

export function FormSmtpConfig(props) {
   const { user: { userData } } = useAuth();
   const [host, setHost] = useState("");
   const [port, setPort] = useState("");
   const [user, setUser] = useState("");
   const [password, setPassword] = useState("");
   const [from, setFrom] = useState("");
   const [secure, setSecure] = useState(false);
   const [smtpTest, setSmtpTest] = useState(null);
   const [isSmtpTesting, setIsSmtpTesting] = useState(false);

   useEffect(() => {
      NotificationsService.getSmtpConfig().then((response) => {
         if (response.data.id) {
            setHost(response.data.smtpHost);
            setPort(response.data.smtpPort);
            setUser(response.data.smtpUser);
            setPassword(response.data.smtpPass);
            setFrom(response.data.smtpFrom);
            setSecure(response.data.smtpSecure);
         }
      });
   }, [userData.selectedOrganizationId]);

   const navigate = useNavigate();

   const handleTest = async () => {
      setIsSmtpTesting(true);
      const payload = buildPayload();
      const response = await NotificationsService.testSmtpConfig(payload);
      setSmtpTest(response.data.success);
      setIsSmtpTesting(false);
      setTimeout(() => {
         setSmtpTest(null);
      }, 3000);
   };

   const buildPayload = () => {
      let payload = {
         smtpHost: host,
         smtpPort: Number(port),
         smtpUser: user,
         smtpPass: password,
         smtpFrom: from,
         smtpSecure: secure,
      };
      return payload;
   };

   async function handleSubmit(event) {
      event.preventDefault();
      if (props.type === "edicao") {
         handleEdit(event);
         return;
      }
      const payload = buildPayload();
      const response = await NotificationsService.saveSmtpConfig(payload);
      if (response.data.id) navigate("../configuracoes/email", {
         state: { refresh: true }
      });
   }

   async function handleEdit(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await NotificationsService.saveSmtpConfig(payload);
      if (response.data.id) navigate("../configuracoes/email");
   }

   return (
      <>
         <Form
            handleSubmit={handleSubmit}
            type={props.type}
            navigateCancelUrl="../configuracoes/email"
            hideCancelButton={true}
         >
            <div className="form-cond-container w-full">
               <div className={`flex flex-col gap-3.5 w-full ${props.type === "consulta" ? "consulta-mode" : ""}`}>
                  <div className="w-full flex gap-3.5">
                     <div className="flex-1">
                        <Input
                           name="host"
                           id="host"
                           labelText="Host *"
                           value={host}
                           onChange={({ target }) => { setHost(target.value); }}
                           disabled={props.type === "consulta"}
                           required={true}
                           tooltipText="Host do servidor SMTP"
                           tooltipVisible={true}
                        />
                     </div>
                     <div className="w-1/4">
                        <Input
                           name="port"
                           id="port"
                           type="number"
                           labelText="Porta *"
                           value={port}
                           onChange={({ target }) => { setPort(target.value); }}
                           disabled={props.type === "consulta"}
                           required={true}
                           tooltipText="Porta do servidor SMTP"
                           tooltipVisible={true}
                        />
                     </div>
                  </div>
                  <div className="w-full grid grid-cols-2 gap-3.5">
                     <Input
                        name="user"
                        id="user"
                        labelText="Usuário *"
                        value={user}
                        onChange={({ target }) => { setUser(target.value); }}
                        disabled={props.type === "consulta"}
                        required={true}
                        tooltipText="Usuário do servidor SMTP"
                        tooltipVisible={true}
                     />

                     <Input
                        labelText={"Senha *"}
                        name="password"
                        id="password"
                        value={password}
                        type="password"
                        autoComplete="off"
                        onChange={({ target }) => setPassword(target.value)}
                        required
                     />
                  </div>
                  <div className="w-full grid grid-cols-2 gap-3.5">
                     <Input
                        name="from"
                        id="from"
                        labelText="Remetente *"
                        value={from}
                        onChange={({ target }) => { setFrom(target.value); }}
                        disabled={props.type === "consulta"}
                        required={true}
                        tooltipText="Email de origem"
                        tooltipVisible={true}
                     />
                     <div
                        className="form-checkbox"
                        style={{
                           flexDirection: props.type === "consulta" ? "column" : "row",
                           marginTop: "25px"
                        }}
                     >
                        <ToggleButton
                           label="TLS"
                           defaultChecked={secure}
                           onChange={({ target }) => setSecure(target.checked)}
                           required={false}
                           disabled={props.type === "consulta"}
                           tooltipText={
                              "Usar TLS"
                           }
                           tooltipVisible={true}
                        />
                     </div>
                  </div>
                  <div className="w-full flex flex-row mt-2! items-center gap-3.5 justify-start">
                     <Button
                        className="button-white w-[180px]!"
                        label="Testar Configuração"
                        onClick={handleTest}
                        disabled={props.type === "consulta"}
                     />
                     {isSmtpTesting ? (
                        <p className="text-(--textColor)">
                           Testando...
                        </p>
                     ) : (
                        <>
                           {smtpTest !== null ? (
                              <>
                                 {smtpTest ? (
                                    <p className="inline-flex items-center gap-1 text-green-400 text-base">
                                       <AiOutlineCheckCircle size={16} />
                                       Sucesso
                                    </p>
                                 ) : (
                                    <p className="inline-flex items-center gap-1 text-red-500 text-base">
                                       <AiOutlineCloseCircle size={16} />
                                       Falha
                                    </p>
                                 )}
                              </>
                           ) : (
                              <></>
                           )}
                        </>
                     )}
                  </div>
               </div>
            </div>
         </Form>
      </>
   );
}
